import React, { useContext, useState, useEffect } from 'react';
import '../../style/vertical.css';
import image from '../../assets/svgs/201.svg';
import CheckProviderDetail from '../../assets/svgs/Check Provider Detail.svg';
import DataunitsAvailableforPurchase from '../../assets/svgs/Data units Available for Purchase.svg';
import profile from '../../assets/svgs/profile.svg';
import logout from '../../assets/svgs/logout.svg';
import VectorDown from '../../assets/svgs/Vector Down.svg';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { LangContext } from '../../utils/contaxt';

const Vertical = () => {
  const Navigate = useNavigate();
  const [OnClickColor, setOnClickColor] = useState('');
  const [isRegisterExpanded, setIsRegisterExpanded] = useState(false);
  const role = localStorage.getItem('role');

  console.log('🚀 ~ Vertical component ~ role from localStorage:', role);
  const { lang, first_Name, Last_Name, setlang, setfirst_Name, setLast_Name } =
    useContext(LangContext);

  const getBasePath = () => {
    const currentUrl = window.location.pathname;
    const pathSegments = currentUrl.split('/').filter((segment) => segment);

    // Adjust the basePath length as needed, here assuming the base path is the first three segments
    const basePathLength = 2; // Adjust this value based on your base path pattern
    const basePath = `/${pathSegments.slice(0, basePathLength).join('/')}`;

    return basePath;
  };
  const currenturl = getBasePath();

  // Check if user is logged in and not on auth pages
  const isLoggedIn = role && !window.location.pathname.includes('/auth/');
  const isAuthPage = window.location.pathname.includes('/auth/');

  return (
    <div className='container'>
      <div className='SmartContractLayout'>TDU FUND</div>
      
      {/* Show auth navigation for login/register pages */}
      {isAuthPage && (
      <div className='ManuContainer'>
          {/* Register Section - Dropdown */}
          <div
            className='ManuContainerItemsTextlayout'
            style={{ marginBottom: '10px', cursor: 'pointer' }}
            onClick={() => setIsRegisterExpanded(!isRegisterExpanded)}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img src={image} style={{ marginRight: '10px', width: '16px', height: '16px' }} />
                <span>Register</span>
              </div>
              <img
                src={VectorDown}
                style={{
                  width: '12px',
                  height: '12px',
                  transform: isRegisterExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease'
                }}
              />
            </div>
          </div>

          {/* Register Options - Show when expanded */}
          {isRegisterExpanded && (
            <>
              {/* Register as Fund Provider */}
              <Link
                to='/auth/registerProvider'
                style={{ all: 'unset', cursor: 'pointer' }}
              >
                <div className='ManuContainerItemsTextlayout' style={{ paddingLeft: '20px', fontSize: '14px' }}>
                  Register as a Fund Provider
            </div>
          </Link>

              {/* Register as Fund Subscriber */}
          <Link
                to='/auth/registerFundSubscriber'
            style={{ all: 'unset', cursor: 'pointer' }}
          >
                <div className='ManuContainerItemsTextlayout' style={{ paddingLeft: '20px', fontSize: '14px' }}>
                  Register as a Fund Subscriber
            </div>
          </Link>
            </>
        )}

          {/* Log In Button */}
          <Link
            to='/auth/Login'
            style={{ all: 'unset', cursor: 'pointer' }}
          >
            <div
              style={{
                cursor: 'pointer',
                background: window.location.pathname === '/auth/Login'
                    ? 'linear-gradient(266.71deg, #0067FD 0%, #003F9A 100%)'
                    : '',
                marginTop: '20px'
              }}
              className='ManuContainerItemsTextlayout'
            >
              <img src={profile} />
              Log In
            </div>
          </Link>
        </div>
        )}

      {/* Show dashboard menu for logged-in users */}
      {isLoggedIn && (
        <div className='ManuContainer'>
        {/* Dashboard - Only for Admin */}
        {role === 'Admin' && (
          <Link
            to='/admin-panel/Dashboard'
            style={{ all: 'unset', cursor: 'pointer' }}
          >
            <div
              style={{
                cursor: 'pointer',
                background:
                OnClickColor == 'Dashboard' ||
                currenturl == '/admin-panel/Dashboard'
                    ? 'linear-gradient(266.71deg, #0067FD 0%, #003F9A 100%)'
                    : '',
              }}
              onClick={() => {
                console.log('=============check');
              setOnClickColor('Dashboard');
              }}
              className='ManuContainerItemsTextlayout'
            >
            <img src={image} />
            Dashboard
            </div>
          </Link>
        )}

        {/* My Profile */}
          <Link
          to={role === 'Admin' ? '/admin-panel/AdminProfile' :
              role === 'Fund Provider' ? '/admin-panel/ProviderProfile' :
              role === 'Fund Subscriber' ? '/admin-panel/FundSubscriberProfile' : '/admin-panel/Dashboard'}
            style={{ all: 'unset', cursor: 'pointer' }}
          >
            <div
              style={{
                cursor: 'pointer',
                background:
                OnClickColor == 'My Profile' ||
                currenturl == '/admin-panel/AdminProfile' ||
                currenturl == '/admin-panel/ProviderProfile' ||
                currenturl == '/admin-panel/FundSubscriberProfile'
                    ? 'linear-gradient(266.71deg, #0067FD 0%, #003F9A 100%)'
                    : '',
              }}
              onClick={() => {
                console.log('=============check');
                setOnClickColor('My Profile');
              }}
              className='ManuContainerItemsTextlayout'
            >
              <img src={profile} />
              My Profile
            </div>
          </Link>

        {/* Provider Approval Request - Only for admin */}
        {role === 'Admin' && (
          <Link
            to='/admin-panel/viewProvider'
            style={{ all: 'unset', cursor: 'pointer' }}
          >
            <div
              style={{
                cursor: 'pointer',
                background:
                  OnClickColor == 'viewProvider' ||
                  currenturl == '/admin-panel/viewProvider'
                    ? 'linear-gradient(266.71deg, #0067FD 0%, #003F9A 100%)'
                    : '',
              }}
              onClick={() => {
                console.log('=============check');
                setOnClickColor('viewProvider');
              }}
              className='ManuContainerItemsTextlayout'
            >
              <img src={image} />
              Provider Approval Request
            </div>
          </Link>
        )}

        {/* Tokenized Fund-Units - Admin only */}
        {role === 'Admin' && (
          <Link
            to='/admin-panel/FundUnits'
            style={{ all: 'unset', cursor: 'pointer' }}
          >
            <div
              style={{
                cursor: 'pointer',
                background:
                  OnClickColor == 'Fund-Units' ||
                  currenturl == '/admin-panel/FundUnits'
                    ? 'linear-gradient(266.71deg, #0067FD 0%, #003F9A 100%)'
                    : '',
              }}
              onClick={() => {
                console.log('=============check');
                setOnClickColor('Fund-Units');
              }}
              className='ManuContainerItemsTextlayout'
            >
              <img src={DataunitsAvailableforPurchase} />
              Tokenized Fund-Units
            </div>
          </Link>
        )}

        {/* Fund Provider - Admin only */}
        {role === 'Admin' && (
          <Link
            to='/admin-panel/FundProvider'
            style={{ all: 'unset', cursor: 'pointer' }}
          >
            <div
              style={{
                cursor: 'pointer',
                background:
                  OnClickColor == 'Fund Provider' ||
                  currenturl == '/admin-panel/FundProvider'
                    ? 'linear-gradient(266.71deg, #0067FD 0%, #003F9A 100%)'
                    : '',
              }}
              onClick={() => {
                console.log('=============check');
                setOnClickColor('Fund Provider');
              }}
              className='ManuContainerItemsTextlayout'
            >
              <img src={CheckProviderDetail} />
              Fund Provider
            </div>
          </Link>
        )}

        {/* Fund Subscriber - Admin only */}
        {role === 'Admin' && (
          <Link
            to='/admin-panel/FundSubscriber'
            style={{ all: 'unset', cursor: 'pointer' }}
          >
            <div
              style={{
                cursor: 'pointer',
                background:
                  OnClickColor == 'Fund Subscriber' ||
                  currenturl == '/admin-panel/FundSubscriber'
                    ? 'linear-gradient(266.71deg, #0067FD 0%, #003F9A 100%)'
                    : '',
              }}
              onClick={() => {
                console.log('=============check');
                setOnClickColor('Fund Subscriber');
              }}
              className='ManuContainerItemsTextlayout'
            >
              <img src={CheckProviderDetail} />
              Fund Subscriber
            </div>
          </Link>
        )}


        {/* Fund Provider role specific menu items */}
        {role === 'Fund Provider' && (
          <>
            {/* Tokenize Fund */}
          <Link
              to='/admin-panel/tokenizeData'
            style={{ all: 'unset', cursor: 'pointer' }}
          >
            <div
              style={{
                cursor: 'pointer',
                background:
                    OnClickColor == 'Tokenize Fund' ||
                    currenturl == '/admin-panel/tokenizeData'
                    ? 'linear-gradient(266.71deg, #0067FD 0%, #003F9A 100%)'
                    : '',
              }}
              onClick={() => {
                console.log('=============check');
                  setOnClickColor('Tokenize Fund');
              }}
              className='ManuContainerItemsTextlayout'
            >
                <img src={image} />
                Tokenize Fund
            </div>
          </Link>

            {/* Your Fund Units */}
          <Link
              to='/admin-panel/YourdataUnit'
            style={{ all: 'unset', cursor: 'pointer' }}
          >
            <div
              style={{
                cursor: 'pointer',
                background:
                    OnClickColor == 'Your Fund Units' ||
                    currenturl == '/admin-panel/YourdataUnit'
                    ? 'linear-gradient(266.71deg, #0067FD 0%, #003F9A 100%)'
                    : '',
              }}
              onClick={() => {
                console.log('=============check');
                  setOnClickColor('Your Fund Units');
              }}
              className='ManuContainerItemsTextlayout'
            >
                <img src={image} />
                Your Fund Units
            </div>
          </Link>

            {/* Sales And Balance */}
          <Link
              to='/admin-panel/SalesBalance'
            style={{ all: 'unset', cursor: 'pointer' }}
          >
            <div
              style={{
                cursor: 'pointer',
                background:
                    OnClickColor == 'Sales And Balance' ||
                    currenturl == '/admin-panel/SalesBalance'
                    ? 'linear-gradient(266.71deg, #0067FD 0%, #003F9A 100%)'
                    : '',
              }}
              onClick={() => {
                console.log('=============check');
                  setOnClickColor('Sales And Balance');
              }}
              className='ManuContainerItemsTextlayout'
            >
                <img src={image} />
                Sales And Balance
            </div>
          </Link>

            {/* Fund Subscriber */}
            <Link
              to='/admin-panel/ProviderFundSubscribers'
              style={{ all: 'unset', cursor: 'pointer' }}
            >
              <div
                style={{
                  cursor: 'pointer',
                  background:
                    OnClickColor == 'Fund Subscriber' ||
                    currenturl == '/admin-panel/ProviderFundSubscribers'
                      ? 'linear-gradient(266.71deg, #0067FD 0%, #003F9A 100%)'
                      : '',
                }}
                onClick={() => {
                  console.log('=============check');
                  setOnClickColor('Fund Subscriber');
                }}
                className='ManuContainerItemsTextlayout'
              >
                <img src={image} />
                Fund Subscriber
              </div>
            </Link>

            {/* Fund Transactions */}
          <Link
              to='/admin-panel/dataTransaction'
            style={{ all: 'unset', cursor: 'pointer' }}
          >
            <div
              style={{
                cursor: 'pointer',
                background:
                    OnClickColor == 'Fund Transactions' ||
                    currenturl == '/admin-panel/dataTransaction'
                    ? 'linear-gradient(266.71deg, #0067FD 0%, #003F9A 100%)'
                    : '',
              }}
              onClick={() => {
                console.log('=============check');
                  setOnClickColor('Fund Transactions');
              }}
              className='ManuContainerItemsTextlayout'
            >
                <img src={image} />
                Fund Transactions
            </div>
          </Link>

            {/* Connect Wallet */}
          <Link
              to='/admin-panel/connectToWallet'
            style={{ all: 'unset', cursor: 'pointer' }}
          >
            <div
              style={{
                cursor: 'pointer',
                background:
                    OnClickColor == 'Connect Wallet' ||
                    currenturl == '/admin-panel/connectToWallet'
                    ? 'linear-gradient(266.71deg, #0067FD 0%, #003F9A 100%)'
                    : '',
              }}
              onClick={() => {
                console.log('=============check');
                  setOnClickColor('Connect Wallet');
              }}
              className='ManuContainerItemsTextlayout'
            >
                <img src={image} />
                Connect Wallet
            </div>
          </Link>
          </>
        )}

        {/* Fund Subscriber role specific menu items */}
        {role === 'Fund Subscriber' && (
          <>
            {/* Buy Fund Assets */}
    <Link
              to='/admin-panel/BuyFundAssets'
            style={{ all: 'unset', cursor: 'pointer' }}
          >
            <div
              style={{
                cursor: 'pointer',
                background:
                    OnClickColor == 'Buy Fund Assets' ||
                    currenturl == '/admin-panel/BuyFundAssets'
                    ? 'linear-gradient(266.71deg, #0067FD 0%, #003F9A 100%)'
                    : '',
              }}
              onClick={() => {
                console.log('=============check');
                  setOnClickColor('Buy Fund Assets');
              }}
              className='ManuContainerItemsTextlayout'
            >
                <img src={image} />
                Buy Fund Assets
            </div>
          </Link>

            {/* Fund Investments */}
          <Link
            to='/admin-panel/FundInvestments'
            style={{ all: 'unset', cursor: 'pointer' }}
          >
            <div
              style={{
                cursor: 'pointer',
                background:
                  OnClickColor == 'Fund Investments' ||
                  currenturl == '/admin-panel/FundInvestments'
                    ? 'linear-gradient(266.71deg, #0067FD 0%, #003F9A 100%)'
                    : '',
              }}
              onClick={() => {
                  console.log('=============check');
                setOnClickColor('Fund Investments');
              }}
              className='ManuContainerItemsTextlayout'
            >
                <img src={image} />
                Fund Investments
            </div>
          </Link>
          </>
        )}

        {/* Log Out */}
          <Link style={{ all: 'unset', cursor: 'pointer' }}>
            <div
              style={{
                cursor: 'pointer',
                background:
                  OnClickColor == 'Log Out'
                    ? 'linear-gradient(266.71deg, #0067FD 0%, #003F9A 100%)'
                    : '',
              }}
              onClick={() => {
                console.log('=============check');
                Swal.fire({
                  title: 'Are you sure?',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes, logout it!',
                }).then((result) => {
                  if (result.isConfirmed) {
                    // Get user role for personalized message
                    const userRole = localStorage.getItem('role');
                    const logoutMessage = userRole === 'Fund Provider' 
                      ? 'Good. You have logged out successfully.' 
                      : 'You logged out successfully.';
                    
                    Swal.fire({
                      title: 'Logout!',
                      text: logoutMessage,
                      icon: 'success',
                    }).then(async (result2) => {
                      if (
                        result2.isConfirmed ||
                        result2.dismiss === Swal.DismissReason.backdrop
                      ) {
                        // Disconnect wallet if MetaMask is available
                        try {
                          if (window.ethereum) {
                            await window.ethereum.request({
                              method: 'wallet_revokePermissions',
                              params: [{ eth_accounts: {} }]
                            });
                            console.log('Wallet disconnected successfully');
                          }
                        } catch (error) {
                          console.log('Wallet disconnection failed:', error);
                          // Continue with logout even if wallet disconnect fails
                        }

                        setlang('');
                        setOnClickColor('Log Out');
                        localStorage.clear();
                        Navigate('/auth/Login');
                      }
                    });
                  }
                });
              }}
              className='ManuContainerItemsTextlayout'
            >
              <img src={logout} />
            Log Out
            </div>
          </Link>
        </div>
        )}
    </div>
  );
};

export default Vertical;
